export default __webpack_public_path__ + "static/media/install.203afb9a.svg";